import { MetaTags } from 'component/MetaTags'
import { meta } from 'feature/meta'
import { UnavailablePage } from 'feature/page/UnavailablePage/UnavailablePage'
import i18next from 'i18next'
import { CatalogPage } from 'page/catalog/Page/CatalogPage'
import { CatalogProvider } from 'page/catalog/store/CatalogContext'
import { useState } from 'react'
import { ui } from 'store/home/ui/HomeUiStore'
import { useOpt } from 'store/opt'
import { DemoCatalogData, useDemoParams } from 'type/demo'

export type Props = {
  data?: DemoCatalogData
  userAgent?: string
  lang?: string
  bundle?: unknown
}

export default function CatalogHtml({ data, userAgent, lang, bundle }: Props) {
  useOpt(data?.product, data?.widget)

  const params = useDemoParams(data?.product?.panelType)
  const { title, icon, description, image } = data?.product ?? {}

  useState(() => {
    ui.setUserAgent(userAgent)
    if (lang && bundle) {
      i18next.addResourceBundle(lang, 'default', bundle)
      void i18next.changeLanguage(lang)
    } else {
      void i18next.changeLanguage('en')
    }
  })

  return (
    <>
      <MetaTags
        title={title || meta.title}
        description={description || meta.description}
        image={image}
        icon={icon || meta.icon}
      />
      {!data && <UnavailablePage stand={params.stand} />}
      {data && (
        <CatalogProvider data={data} params={params}>
          <CatalogPage />
        </CatalogProvider>
      )}
    </>
  )
}
